import router from "@/router";
import { createApp, provide, inject } from "vue";
import * as axios from "axios";
import store from "@/store";
import qs from "qs";
import { ElMessage } from "element-plus";
import Axios from "axios";
import { AxiosResponse, AxiosRequestConfig } from "axios";
import utils from "../utils/utils";
import bus from "../bus";

/**
 * 测试环境 dev;
 * 生产环境 prod;
 */
const env = ["prod", "dev"][0];

const { baseURL, authorURL, privewURL }: any = ({
  dev: {
    baseURL: "http://175.155.245.5:6080/",
    authorURL: "https://test.diswdata.com:7200/login/",
    privewURL: "http://175.155.245.5:8012/",
  },
  prod: {
    baseURL: "https://hxzs1993.com:6080/",
    authorURL: "https://hxzs1993.com:6066/",
    privewURL: "https://hxzs1993.com/preview/",
  },
} as any)[env];

const tokenStr = "hxToken";

const service: any = axios.default.create({
  baseURL,
  timeout: 0,
  withCredentials: true,
  maxContentLength: 4000,
});
// 是否正在刷新的标记
let isRefreshing = false;
// 重试队列，每一项将是一个待执行的函数形式
let requests: any = [];

//获取token
function getToken() {
  return utils.$cookie.getCookie(tokenStr);
}

//刷新token
function refreshTokenFn() {
  const refreshToken = utils.$cookie.getCookie("hxRefreshToken");
  return service
    .get(
      `${authorURL}oauth/refresh/industrial-web-api?refreshToken=${refreshToken}`
    )
    .then((res: any) => {
      return res;
    });
}

function clearNotice(){
  const noticeHtmlList:any = document.getElementsByClassName('el-notification');
  for(let i = noticeHtmlList.length - 1; i >= 0; i--){
    if(noticeHtmlList[i] !== undefined)
    noticeHtmlList[i].parentNode.removeChild(noticeHtmlList[i]);
  }
}

//给service添加一个setToken的方法。用户登录后方便将最新的token动态添加到header，同时将token保存起来
service.setToken = (str: string) => {
  service.defaults.headers["Authorization"] = str;
  utils.$cookie.addCookie("hxToken", str, "100");
};

service.interceptors.request.use(
  (config: any) => {
    const url = config.url || "";
    const token = getToken(),
      disTime = utils.$cookie.getCookie("hxExpiresIn"),
      expressTime = utils.$cookie.getCookie("hxExpiresTime");

    //登录接口绕过token
    if (url.indexOf("oauth/token") !== -1 || url.indexOf("login") !== -1 || url.indexOf("https://hxzs1993.com:6066/") !== -1 || url.indexOf("https://test.diswdata.com:7200/") !== -1) {
      delete config.headers["Authorization"];
      return config;
    } else {
      config.headers["Authorization"] = decodeURIComponent(token);
    }
    if (token && disTime) {
      const nowTime = new Date().getTime();

      if (nowTime >= parseInt(disTime) * 1000 + parseInt(expressTime)) {
        //立即刷新token
        if (!isRefreshing) {
          isRefreshing = true;
          refreshTokenFn()
            .then((res: any) => {
              bus.$emit("refreshFlag", true);
              utils.$cookie.removeCookie("hxToken");
              utils.$cookie.removeCookie("hxRefreshToken");
              utils.$cookie.removeCookie("hxExpiresIn");
              utils.$cookie.removeCookie("hxExpiresTime");
              const { access_token, expires_in } = res;
              utils.$cookie.addCookie("hxToken", "Bearer " + res.access_token);
              utils.$cookie.addCookie("hxRefreshToken", res.refresh_token);
              utils.$cookie.addCookie("hxExpiresIn", res.expires_in);
              utils.$cookie.addCookie("hxExpiresTime", new Date().getTime());
              isRefreshing = false;
              return access_token;
            })
            .then((token: any) => {
              requests.forEach((cb: any) => {
                cb(token);
              });
              requests = [];
            })
            .catch((res: any) => {
              console.error("refresh token error: ", res);
              ElMessage({
                message: "登录信息过期，请重新登录!",
                showClose: true,
                type: "warning",
              });
              setTimeout(function () {
                utils.$cookie.clearToken();
                clearNotice();
                router.push({
                  path: "/login",
                });
              }, 2000);
            });
        }
        const retryOriginalRequest = new Promise((resolve) => {
          requests.push((token: any) => {
            config.headers["Authorization"] = decodeURIComponent(
              "Bearer " + token
            );
            resolve(config);
          });
        });
        return retryOriginalRequest;
      }
    }
    return config;
  },
  (error: any) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response: AxiosResponse) => {
    if (response.config.responseType === "blob") {
      return response;
    }
    if (response.status !== 200) {
      ElMessage.error("请求错误!");
    } else {
      const data = response.data;
      const resCode = data.code;
      const msg = data.msg;
      if (resCode === 400 || resCode === 403) {
        ElMessage({
          message: msg,
          showClose: true,
          type: "warning",
        });
        return Promise.reject();
      } else if (resCode === 500) {
        ElMessage({
          message: "服务器内部错误!",
          showClose: true,
          type: "warning",
        });
        return Promise.reject();
      } else if (resCode === 401) {
        ElMessage({
          message: "登录信息过期，请重新登录!",
          showClose: true,
          type: "warning",
        });
        setTimeout(function () {
          utils.$cookie.clearToken();
          clearNotice();
          router.push({
            path: "/login",
          });
        }, 2000);
        return Promise.reject();
      } else if (resCode === 200) {
        const result = data.data || true;
        return result;
      }
    }
  },
  (error: any) => {
    if (error && error.response) {
      const resCode = error.response.status;

      if (resCode === 400 || resCode === 403) {
        ElMessage({
          message: "网络错误!",
          showClose: true,
          type: "warning",
        });
        return false;
      } else if (resCode === 500) {
        ElMessage({
          message: "服务器内部错误!",
          showClose: true,
          type: "warning",
        });
        return false;
      } else if (resCode === 401) {
        ElMessage({
          message: "登录信息过期，请重新登录!",
          showClose: true,
          type: "warning",
        });
        setTimeout(function () {
          utils.$cookie.clearToken();
          clearNotice();
          router.push({
            path: "/login",
          });
        }, 2000);
        return false;
      }
    }
    return Promise.reject(error);
  }
);

//ajax方法的封装
const ajax = function (config: any) {
  const method = config.method.toLowerCase() || "get";
  const url = config.url || "";
  const dataType = config.dataType || "normal";
  const data = config.data || {};
  const headers = config.headers || {};
  const type = config.type || "";
  const isAuthRequest = config.isAuthRequest || false;

  if (method === "get") {
    return service.get((isAuthRequest ? "" : baseURL) + url, {
      params: data,
      timeout: 30000,
      responseType: type,
      paramsSerializer: (params: any) => {
        return qs.stringify(params, { indices: false });
      },
    });
  } else if (method === "put") {
    return service.put((isAuthRequest ? "" : baseURL) + url, data);
  } else if (method === "delete") {
    return service.delete((isAuthRequest ? "" : baseURL) + url, {
      data: data,
    });
  } else if (method === "patch") {
    return service.patch((isAuthRequest ? "" : baseURL) + url, data);
  } else {
    if (dataType === "form") {
      return service.post(
        (isAuthRequest ? "" : baseURL) + url,
        qs.stringify(config.data),
        {
          headers,
        }
      );
    } else {
      return service.post((isAuthRequest ? "" : baseURL) + url, data, {
        headers,
      });
    }
  }
};

export { ajax, baseURL, authorURL, privewURL };
